import {
    Carousel,
    initTE,
} from "tw-elements";

// Make initTE available globally
window.initTE = initTE;
window.Carousel = Carousel;

// Track if carousels have been initialized
let carouselsInitialized = false;

// Initialize carousels function
function initializeCarousels() {
    if (carouselsInitialized) return;
    
    const carousels = document.querySelectorAll('[data-te-carousel-init]');
    if (carousels.length > 0) {
        carousels.forEach(carousel => {
            // Check if carousel is already initialized
            if (!carousel.hasAttribute('data-te-carousel-initialized')) {
                // Initialize the carousel
                if (typeof initTE !== 'undefined') {
                    initTE({ Carousel });
                }
                // Mark as initialized to prevent double initialization
                carousel.setAttribute('data-te-carousel-initialized', 'true');
            }
        });
        carouselsInitialized = true;
    }
}

// Initialize slider indicators
function initializeSliderIndicators() {
    const wrappers = document.querySelectorAll('.slider-wrapper');
    wrappers.forEach(wrapper => {
        updateSliderIndicators(wrapper);
    });
}

function updateSliderIndicators(wrapper) {
    const indicatorsToShow = 4;
    const indicatorWidth = 18; // 12px width + 6px margin (3px on each side)

    const indicatorsContainer = wrapper.querySelector('[data-te-carousel-indicators]');
    const indicators = wrapper.querySelectorAll('.carousel-indicator');
    if (!indicatorsContainer || indicators.length <= indicatorsToShow) return;

    let currentActiveIndex = 0;

    function updateIndicatorsPosition(activeIndex) {
        let translateX = 0;
        if (activeIndex == 0) {
            translateX = 0;
        }
        else if(activeIndex >= Math.floor(indicatorsToShow / 2)) {
            const centerPosition = Math.floor(indicatorsToShow / 2);
            const maxTranslate = (indicators.length - indicatorsToShow) * indicatorWidth;

            if (activeIndex <= indicators.length - Math.ceil(indicatorsToShow / 2)) {
                translateX = (activeIndex - centerPosition) * indicatorWidth;
            } else {
                translateX = maxTranslate;
            }
        }
        indicatorsContainer.style.transform = `translateX(-${translateX}px)`;
    }

    updateIndicatorsPosition(currentActiveIndex);

    // Listen for carousel slide event (Tailwind Elements events)
    wrapper.addEventListener('slide.te.carousel', (e) => {
        if (e && typeof e.to !== 'undefined') {
            currentActiveIndex = e.to;
            updateIndicatorsPosition(currentActiveIndex);
        }
    });
}

// Function to handle content changes (for pagination/filtering)
function handleContentChange() {
    // Reset initialization flag when content changes
    carouselsInitialized = false;
    
    // Use MutationObserver to wait for DOM changes, then RAF for smooth rendering
    const observer = new MutationObserver((mutations) => {
        observer.disconnect();
        requestAnimationFrame(() => {
            initializeCarousels();
            initializeSliderIndicators();
        });
    });
    
    // Observe DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Fallback: if no mutations detected within 200ms, initialize anyway
    setTimeout(() => {
        if (observer.takeRecords().length === 0) {
            observer.disconnect();
            requestAnimationFrame(() => {
                initializeCarousels();
                initializeSliderIndicators();
            });
        }
    }, 200);
}

// Initialize on first interaction
function initializeOnInteraction() {
    // Use requestAnimationFrame for smooth initialization
    requestAnimationFrame(() => {
        initializeCarousels();
        initializeSliderIndicators();
    });
    
    // Remove all interaction listeners after first initialization
    ["mousemove", "click", "scroll", "touchstart", "touchmove", "touchend"].forEach(event => {
        document.removeEventListener(event, initializeOnInteraction);
    });
}

// Add interaction listeners for lazy loading (including mobile-specific events)
["mousemove", "click", "scroll", "touchstart", "touchmove", "touchend"].forEach(event => {
    document.addEventListener(event, initializeOnInteraction, { once: true, passive: true });
});

// Make functions available globally for Livewire events
window.handleContentChange = handleContentChange;
window.initializeCarousels = initializeCarousels;
window.initializeSliderIndicators = initializeSliderIndicators;
